export const ChartPrint = (text) => {
  let maxWidth = "210mm"
  if(text === "Thống kê chi tiết dự án quy hoạch phân khu 1/5000") {maxWidth = "100%"}
  var windowContent = "<!DOCTYPE html>";
  windowContent += "<html>";
  windowContent += "<head>";
  windowContent += "<title> </title>";
  windowContent +=
    '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">';
  windowContent +=
    '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/antd/4.8.2/antd.min.css" integrity="sha512-CPolmBEaYWn1PClN5taQQ0ucEhAt+9j7+Tiog/SblkFjZ5k6M3TioqmlpcHKwUhIcsu1s7lgnX4Plsb6T8Kq5A==" crossorigin="anonymous" />';
  windowContent += `<link href="https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=vietnamese" rel="stylesheet">`;
  windowContent += `
      <style>
      #chart-table {
        /* font-family: "Trebuchet MS", Arial, Helvetica, sans-serif; */
        border-collapse: collapse;
        width: 100%;
      }
      
      #chart-table td, #chart-table th {
        border: 1px solid  #C4C4C4;
        padding: 8px;
        font-size: 15px;
        height: 40px;
        text-align: center;
      }
     #chart-table th {
        background-color: #F2F6FB;
      }
      </style>

    `;

  windowContent += "</head>";
  windowContent += "<body>";
  windowContent += `<div style="max-width: ${maxWidth};">`;
  windowContent += `<div style="font-size: 16px;font-weight: bold;margin-bottom: 20px;">${text}</div>`;
  windowContent += `<table id = "chart-table">`;
  windowContent += document.getElementById(`chart-table`).innerHTML;
  windowContent += "</table>";

  windowContent +=
    '<script src="https://cdnjs.cloudflare.com/ajax/libs/antd/4.8.2/antd.min.js" integrity="sha512-oHALdU5OO+FSQGCno//1Jqi69ERPucovxrFMGZxfNvQSL4P0WVf0i9yU81gBh2RSzIebQb9NrTloSizJ7Vtpew==" crossorigin="anonymous"></script>';
  windowContent += `</div>`;
  windowContent += "</body>";
  windowContent += "</html>";
  // var printWin = window.open();
  let printWin = window.open('', '', 'width=1024,height=768');
  printWin.document.open();
  printWin.document.write(windowContent);

  printWin.document.close(); // necessary for IE >= 10
  printWin.moveTo(0, 0);
  printWin.resizeTo(window.screen.width, window.screen.height);
  printWin.focus(); // necessary for IE >= 10*/
  printWin.print();

  if (window.innerWidth > 1024) {
    // setTimeout(()=>{printWin.close()},400)
  }

  // printWin.close();

  return true;
};

export default ChartPrint
